import { render, staticRenderFns } from "./ShowUserAdmin.vue?vue&type=template&id=2146fdbd&scoped=true&"
import script from "./ShowUserAdmin.vue?vue&type=script&lang=ts&"
export * from "./ShowUserAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./ShowUserAdmin.vue?vue&type=style&index=0&id=2146fdbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2146fdbd",
  null
  
)

export default component.exports